import { render, staticRenderFns } from "./regList.vue?vue&type=template&id=6332c1b5&scoped=true&"
import script from "./regList.vue?vue&type=script&lang=js&"
export * from "./regList.vue?vue&type=script&lang=js&"
import style0 from "./regList.vue?vue&type=style&index=0&id=6332c1b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6332c1b5",
  null
  
)

export default component.exports